import { cn } from '@/lib/utils';
import type { RichObjectKind } from '@/mock';
import { NotebookTextIcon } from '@/shared/icon-library';
import type { LucideIcon } from '@/shared/icon-library';
import { OBJECT_ICON } from '@/shared/icons';

export const OBJECT_REF_ICON: Record<RichObjectKind, LucideIcon> = {
  task: OBJECT_ICON.task,
  channel: OBJECT_ICON.channel,
  user: OBJECT_ICON.person,
  doc: NotebookTextIcon,
};

interface ObjectChipProps {
  kind: RichObjectKind;
  label: string;
  onOpen?: () => void;
}

export function ObjectChip({ kind, label, onOpen }: ObjectChipProps) {
  const Icon = OBJECT_REF_ICON[kind];
  return (
    <button
      type="button"
      data-object-kind={kind}
      onClick={onOpen}
      className={cn(
        'mx-px inline-flex max-w-full items-baseline gap-1 rounded-sm bg-selected-quiet px-1 align-baseline text-[0.95em] text-foreground',
        onOpen ? 'cursor-pointer hover:bg-selected' : 'cursor-default',
      )}
    >
      <Icon className="size-3.5 translate-y-0.5 shrink-0 text-foreground-muted" aria-hidden />
      <span className="truncate">{label}</span>
    </button>
  );
}
